// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"54":"a1749db9","184":"26ca9b82","211":"2ffc604f","226":"49bc27d6","253":"e6abbee3","262":"8f9fb09b","430":"577c2961","484":"ec3455b1","579":"e953c317","812":"48cf187a","917":"bad928e4","935":"c6180389","993":"e5e14e13"}[chunkId] + ".js";
};